
// Login Success Response
export const loginResponse = {
    "_id": "6172e81e19fe673f5dc925c9",
    "name": "test",
    "email": "test@gmail.com",
    "isAdmin": false,
    "isSeller": false,
    "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MTcyZTgxZTE5ZmU2NzNmNWRjOTI1YzkiLCJuYW1lIjoibXVza2FuIiwiZW1haWwiOiJtdXNrYW5AZ21haWwuY29tIiwiaXNBZG1pbiI6ZmFsc2UsImlzU2VsbGVyIjpmYWxzZSwiaWF0IjoxNjM1MDEzNzk1LCJleHAiOjE2Mzc2MDU3OTV9.Sxe7x1-8vSPRrq38srqdIVxJ43LzLSvKz4roaUT2mwQ"
}

// Trending data
export const trendings = ['Best Seller', 'New Releases']

// Help and Settings
export const helpAndSettings = ['Your Accounts', 'Customer Service', 'Logout']

// Categories with Sub-Categories Data
export const categories = ['Clothing', 'Shoes'];
export const categoriesResponse = [
  {
      "_id": "65e5e627bb3b32b68e39c4fe",
      "name": "Shoes",
      "createdAt": "2024-03-04T15:17:59.672Z",
      "updatedAt": "2024-03-04T15:17:59.672Z",
      "__v": 0
  },
  {
      "_id": "65e5e61cbb3b32b68e39c4fb",
      "name": "Clothing",
      "createdAt": "2024-03-04T15:17:48.669Z",
      "updatedAt": "2024-03-04T15:17:48.669Z",
      "__v": 0
  }
]

export const subCategoryresponse = [
  {
      "_id": "65e5e680bb3b32b68e39c53c",
      "name": "Kid's Shoes",
      "category_id": "65e5e627bb3b32b68e39c4fe",
      "__v": 0
  },
  {
      "_id": "65e5e675bb3b32b68e39c539",
      "name": "Women's Shoes",
      "category_id": "65e5e627bb3b32b68e39c4fe",
      "__v": 0
  },
  {
      "_id": "65e5e66bbb3b32b68e39c536",
      "name": "Men's Shoes",
      "category_id": "65e5e627bb3b32b68e39c4fe",
      "__v": 0
  },
  {
      "_id": "65e5e65ebb3b32b68e39c533",
      "name": "Kid's Clothing",
      "category_id": "65e5e61cbb3b32b68e39c4fb",
      "__v": 0
  },
  {
      "_id": "65e5e64cbb3b32b68e39c530",
      "name": "Women's Clothing",
      "category_id": "65e5e61cbb3b32b68e39c4fb",
      "__v": 0
  },
  {
      "_id": "65e5e63ebb3b32b68e39c52d",
      "name": "Men's Clothing",
      "category_id": "65e5e61cbb3b32b68e39c4fb",
      "__v": 0
  }
]

// Top Sellers
export const topSellersResponse = [
  {
      "isAdmin": false,
      "isSeller": true,
      "_id": "65e9de1037fe17dcba2c4868",
      "name": "Seller 2",
      "email": "seller2@pridim.com",
      "seller": {
          "rating": 4.8,
          "numReviews": 8,
          "_id": "65e9de1037fe17dcba2c4869",
          "name": "Bata Shoe seller",
          "logo": "/images/1709825464491.jpg",
          "description": "Best casual and formal shoes seller",
          "createdAt": "2024-03-07T15:32:32.785Z",
          "updatedAt": "2024-03-07T15:32:32.785Z"
      },
      "createdAt": "2024-03-07T15:32:32.786Z",
      "updatedAt": "2024-03-07T15:32:32.786Z",
      "__v": 0
  },
  {
      "isAdmin": false,
      "isSeller": true,
      "_id": "65e5ef2473bd76c53a5c38ed",
      "name": "Seller 1",
      "email": "seller@pridim.com",
      "seller": {
          "rating": 4.5,
          "numReviews": 120,
          "_id": "65e5ef2473bd76c53a5c38ee",
          "name": "Levi's",
          "logo": "/images/1709824345439.jpg",
          "description": "Best formal cloths seller",
          "createdAt": "2024-03-04T15:56:20.227Z",
          "updatedAt": "2024-03-04T15:56:20.227Z"
      },
      "createdAt": "2024-03-04T15:56:20.228Z",
      "updatedAt": "2024-03-04T15:56:20.228Z",
      "__v": 0
  }
]

// Products Data
export const productsResponse = {
  "products": [
      {
          "colors": [
              "Blue",
              "Black"
          ],
          "size": [
              "S",
              "M"
          ],
          "availableInLocations": [
              "233300"
          ],
          "rating": 4.3,
          "numReviews": 0,
          "_id": "65ef1b08641a9910b0d1b32e",
          "name": "Levi's Boy's Jeans",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1710168830886.jpg",
          "price": 1099,
          "countInStock": 3,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Kid's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-11T14:54:00.708Z",
          "updatedAt": "2024-03-11T14:54:00.708Z",
          "__v": 0
      },
      {
          "colors": [
              "Red",
              "White",
              "Black"
          ],
          "size": [
              "S",
              "M",
              "XL"
          ],
          "availableInLocations": [
              "233300"
          ],
          "rating": 3.5,
          "numReviews": 3,
          "_id": "65eb5616fb903203b8fba36d",
          "name": "levi's women's t-shirt",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709921758797.jpg",
          "price": 299,
          "countInStock": 19,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Women's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-08T18:16:54.145Z",
          "updatedAt": "2024-03-08T18:16:54.145Z",
          "__v": 0
      },
      {
          "colors": [
              "Red",
              "Green",
              "Yellow",
              "Blue",
              "White",
              "Black",
              "Orange"
          ],
          "size": [
              "S",
              "M",
              "L",
              "XL"
          ],
          "availableInLocations": [
              "[233300]"
          ],
          "rating": 4.1,
          "numReviews": 3,
          "_id": "65eb1196fb903203b8fba31e",
          "name": "Men's slim fit formal shirt",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709904244561.jpg",
          "price": 599,
          "countInStock": 12,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Men's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-08T13:24:38.863Z",
          "updatedAt": "2024-03-08T13:24:38.863Z",
          "__v": 0
      },
      {
          "colors": [
              "Black"
          ],
          "size": [
              "M",
              "S"
          ],
          "availableInLocations": [
              "[233001]"
          ],
          "rating": 4,
          "numReviews": 3,
          "_id": "65eb0629fb903203b8fba2af",
          "name": "Bata black kid's shoes",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709901262549.jpg",
          "price": 399,
          "countInStock": 4,
          "brand": "Bata",
          "category": "Shoes",
          "subcategory": "Kid's Shoes",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-08T12:35:53.596Z",
          "updatedAt": "2024-03-08T12:35:53.596Z",
          "__v": 0
      },
      {
          "colors": [
              "Blue",
              "Navy Blue",
              "Black"
          ],
          "size": [
              "S",
              "M",
              "L"
          ],
          "availableInLocations": [
              "233300"
          ],
          "rating": 4.1,
          "numReviews": 2,
          "_id": "65eae1857fcf8eee5e7617ea",
          "name": "Women's Jeans",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709891857246.jpg",
          "price": 1499,
          "countInStock": 12,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Women's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-08T09:59:33.451Z",
          "updatedAt": "2024-03-08T09:59:33.451Z",
          "__v": 0
      },
      {
          "colors": [],
          "size": [],
          "availableInLocations": [
              "233300"
          ],
          "rating": 3.9,
          "numReviews": 2,
          "_id": "65eadef57fcf8eee5e7617c3",
          "name": "Bata casual men's shoes",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709891261626.jpg",
          "price": 1899,
          "countInStock": 4,
          "brand": "Bata",
          "category": "Shoes",
          "subcategory": "Men's Shoes",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-08T09:48:37.971Z",
          "updatedAt": "2024-03-08T09:48:37.971Z",
          "__v": 0
      },
      {
          "colors": [],
          "size": [],
          "availableInLocations": [],
          "rating": 4.2,
          "numReviews": 2,
          "_id": "65e9d71386c002dbd28e2e16",
          "name": "Bata formal Shoe",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709824614686.jpg",
          "price": 1899,
          "countInStock": 12,
          "brand": "Bata",
          "category": "Shoes",
          "subcategory": "Men's Shoes",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-07T15:02:43.424Z",
          "updatedAt": "2024-03-07T15:16:57.462Z",
          "__v": 0
      },
      {
          "colors": [],
          "size": [],
          "availableInLocations": [],
          "rating": 3,
          "numReviews": 2,
          "_id": "65e9d6318a3beedab511a8aa",
          "name": "Men's trouser pant",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709824630278.jpg",
          "price": 1199,
          "countInStock": 4,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Men's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-07T14:58:57.734Z",
          "updatedAt": "2024-03-07T15:17:11.948Z",
          "__v": 0
      },
      {
          "colors": [],
          "size": [],
          "availableInLocations": [],
          "rating": 3,
          "numReviews": 0,
          "_id": "65e9cb6fbc8bbfd7081e51f8",
          "name": "Slim fit formal shirt",
          "seller": {
              "_id": "65e5ef2473bd76c53a5c38ed",
              "seller": {
                  "name": "Levi's",
                  "logo": "/images/1709824345439.jpg"
              }
          },
          "image": "/images/1709824659004.jpg",
          "price": 499,
          "countInStock": 5,
          "brand": "Levi's",
          "category": "Clothing",
          "subcategory": "Men's Clothing",
          "about": [],
          "additionalInformation": [],
          "reviews": [],
          "createdAt": "2024-03-07T14:13:03.883Z",
          "updatedAt": "2024-03-07T15:17:40.841Z",
          "__v": 0
      }
  ],
  "page": 1,
  "pages": 1
}

// Selected Product Response
export const selectedProductResponse = {
    "_id": "617190bf86f7423993baaf8a",
    "name": "sample name 1634832575324",
    "seller": {
      "seller": {
        "rating": 0,
        "numReviews": 0,
        "name": "khyati",
        "logo": "sakha"
      },
      "_id": "6171908786f7423993baaf6f"
    },
    "image": "/images/p1.jpg",
    "price": 0,
    "category": "sample category",
    "brand": "sample brand",
    "countInStock": 0,
    "rating": 0,
    "numReviews": 0,
    "description": "sample description",
    "reviews": [],
    "createdAt": "2021-10-21T16:09:35.331Z",
    "updatedAt": "2021-10-21T16:09:35.331Z",
    "__v": 0
}